export const clearSupabaseAuthToken = () => {
  try {
    // Supabase v2 stores the auth token under a key that looks like
    //   sb-<PROJECT_REF>-auth-token
    // We don't want to hard-code the project ref, so we clear anything that
    // matches that pattern.
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && /^sb-.*-auth-token$/.test(key)) {
        localStorage.removeItem(key);
      }
    }

    // Clear profile setup data that shouldn't persist across different user sessions
    const profileKeys = [
      'filmmaker-profile-basic',
      'filmmaker-profile-professional', 
      'filmmaker-profile-portfolio',
      'filmmaker-profile-image',
      'filmmaker-service-images',
      'filmmaker-portfolio-images',
      'clientProfileBasic',
      'clientProfileImage'
    ];
    
    profileKeys.forEach(key => {
      localStorage.removeItem(key);
    });

  } catch (err) {
    // Safari can throw when storage is inaccessible (private mode, etc.)
    console.error('Error while clearing Supabase auth token', err);
  }
}; 